import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerServiceComponent } from './customer-service.component';
import { CustomerServiceService } from './customer-service.service';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchClientComponent } from './search-client/search-client.component';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		TextMaskModule,
		NgxMaskModule.forRoot(),
	],
	declarations: [
		CustomerServiceComponent,
		SearchClientComponent
	],
	exports: [
		CustomerServiceComponent
	],
	providers: [
		CustomerServiceService,
	]
})
export class CustomerServiceModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/customer-service/customer-service.module.ts